import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import EditTagModal from '../../Modals/Tag/EditTagModal';
import style from './styles/style.module.css';

class InfiniteTagsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            tagInEdit: null,
            tagInEditIndex: -1,
        };
    }
    updateTag = ( index, desireid, data ) => {
        this.props.updateTag( desireid, data )
        .then( ( tag ) => {
            return this.props.onTagUpdated && this.props.onTagUpdated( index, tag );
        } );
    }
    openEditModal = ( index, tag ) => {
        this.setState( { tagInEdit: tag, tagInEditIndex: index } );
    }
    onEditSubmit = ( tag ) => {
        var index = this.state.tagInEditIndex;
        this.props.onTagUpdated( index, tag );
        this.setState( { tagInEdit: null, tagInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { tagInEdit: null, tagInEditIndex: -1 } );
    }



    render() {
        const { tags } = this.props;
        const { tagInEdit } = this.state;

        return (
            <div>
                <InfiniteTable
                className={ style.tagsTable }
                elementHeight={ 90 }>
                    { this.arrayTableRows( tags ) }
                </InfiniteTable>
                { tagInEdit !== null &&
                    <EditTagModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    tag={ tagInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( tags ) => {
        var rows = tags.map( ( tag, index ) => {
            return (
                <InfiniteTable.Row key={ tag.tagid } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.tagtext }>
                        { tag.tagtext }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, tag );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    TAG { sortIcon( 'tagtext,tagid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
InfiniteTagsTable.defaultProps = {
    onTagUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateTag: ( desireid, data ) => {
            return dAPI.patch( `/desires/${ desireid }`, dAPI.clean.tag( data ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( InfiniteTagsTable );
